import { getAuthDataCall, postAuthDataCall, postAuthDataCall2 } from '../utils';

export const getCheckout = async () => {
    const resp = await getAuthDataCall(`/auth/checkout`);
    return resp;
};

export const placeCheckout = async (payload) => {
    const resp = await postAuthDataCall2('/auth/orders', payload);
    return resp;
};

export const grantFreeAccess = async (payload) => {
    const resp = await postAuthDataCall('/auth/free-product', payload);
    return resp;
};

export const promocode = async (payload) => {
    const resp = await postAuthDataCall('/auth/promoCode', payload);
    return resp;
};

export const getPaymentMethods = async () => {
    const resp = await getAuthDataCall('/auth/payment-methods');
    return resp;
};

export const placeManualCheckout = async (payload) => {
    const resp = await postAuthDataCall2('/auth/orders/manual', payload);
    return resp;
};
